import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import TripProviderCreatePage from './trip-provider-create'
import TripProviderListPage from './trip-provider-list'
import UpdateTripProviderPage from './trip-provider-update'

const tripProviderRoutes: Route[] = [
  {
    path: Paths.TRIP_PROVIDER_LIST_PAGE,
    element: <TripProviderListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.TRIP_PROVIDER_CREATE_PAGE,
    element: <TripProviderCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.TRIP_PROVIDER_UPDATE_PAGE,
    element: <UpdateTripProviderPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default tripProviderRoutes
